<template>
  <section class="brandStory_main">
    <div class="container in_wrap">
      <div>
        <p>
          <span>당신의 삶을 건강하고</span>
          아름답게 변화시키는
        </p>
        <p class="msg">
          ECO-TECH 퍼스널 케어
        </p>
        <a href="" class="go" @click.prevent="$router.push('/brandstory')">자세히보기</a>
      </div>
      <div class="different">
        <div class="logo_wrap">
          <img
            src="@/assets/images/common/logo_botalab_white.svg"
            class="logo"
            alt="incellderm"
          />
        </div>
        <p class="txt">
          지금까지 경험하지 못했던 퍼스널케어를 <span class="brs"></span>선보이기 위해 보타랩은 특별한 원칙을 추구합니다. <br>
          많은 것을 담기 보다는 꼭 필요한 성분만을 효율적으로 <span class="brs"></span>배합하여 최적의 솔루션을 제시합니다.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BrandStory',
};
</script>

<style></style>
